import { render, staticRenderFns } from "./ActiveRestaurantAdmin.vue?vue&type=template&id=dabe88f4"
import script from "./ActiveRestaurantAdmin.vue?vue&type=script&lang=js"
export * from "./ActiveRestaurantAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dabe88f4')) {
      api.createRecord('dabe88f4', component.options)
    } else {
      api.reload('dabe88f4', component.options)
    }
    module.hot.accept("./ActiveRestaurantAdmin.vue?vue&type=template&id=dabe88f4", function () {
      api.rerender('dabe88f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/ActiveRestaurantAdmin.vue"
export default component.exports